module.exports = __webpack_public_path__ + "img/products_big_can_watermelon.c14464c2.png";